import { ObjectTypes, Services } from '@diligentcorp/rc-service-object-mapping';

export function getServiceForObjectType(objectType: string): string {
  switch (objectType) {
    case ObjectTypes.EVIDENCE:
    case ObjectTypes.CONTROL:
    case ObjectTypes.CONTROL_ASSESSMENT:
      return Services.INTERNAL_CONTROLS;
    case ObjectTypes.PROCESS:
    case ObjectTypes.OBJECTIVE:
    case ObjectTypes.RISK:
    case ObjectTypes.RISK_MITIGATION:
    case ObjectTypes.RISK_EVENT_ASSESSMENT:
      return Services.RISK_MANAGER;
    default:
      throw new Error(
        `Unsupported object type for service resolution: ${objectType}`,
      );
  }
}
